(() => {
  if (window.sleepyRemoval) return;
  window.sleepyRemoval = true;
  const configNode = document.querySelector('[data-removal-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  config.variants = config.variants || [];
  let hasRemoval = !!config.requested || !!config.hasService;
  const markSelection = selected => {hasRemoval=selected;document.documentElement.classList.toggle('scr-removal-selected',selected);};
  markSelection(hasRemoval);
  const root = window.Shopify?.routes?.root || '/';
  const keys = {requested: 'Old-mattress removal', street: 'Collection street address', locality: 'Collection locality', postcode: 'Collection postcode'};
  const normal = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase().replace(/\s+/g, ' ');
  const zoneFor = locality => config.zones[normal(locality)] || null;
  const priceFor = locality => ({Base: 5000, Near: 8000, Middle: 8000, 'Outer cap': 10000})[zoneFor(locality)] || null;
  const service = item => item.handle === config.handle || item.properties?._sleepy_removal === 'v1';
  const eligible = item => config.eligibleIds.includes(Number(item.product_id));
  const money = cents => new Intl.NumberFormat('en-NZ', {style:'currency', currency:'NZD'}).format(cents / 100);
  const api = async (path, body) => {
    const response = await fetch(root + path, {method: body ? 'POST' : 'GET', headers: {'Accept': 'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body: JSON.stringify(body)} : {}), cache: 'no-store'});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Unable to save your collection details. Please try again.');
    return data;
  };
  let pending = Promise.resolve();
  const enqueue = action => {
    const operation=pending.catch(()=>{}).then(action);
    pending=operation;
    operation.catch(()=>{if(pending===operation) pending=Promise.resolve();});
    return operation;
  };
  const attributes = values => {
    if (Object.hasOwn(values, keys.requested)) markSelection(!!values[keys.requested]);
    return enqueue(()=>api('cart/update.js',{attributes:values}));
  };
  const contact = 'We cannot confidently match this locality to a covered zone. Please contact SleepyCo on 027 533 7920 before adding removal. Islands are unavailable.';
  const readAddress = container => Object.fromEntries(['street','locality','postcode'].map(key => [key, container.querySelector(`[data-removal-${key}]`)?.value.trim() || '']));
  const validAddress = (container, report = true) => {
    const address = readAddress(container);
    const street = container.querySelector('[data-removal-street]');
    const locality = container.querySelector('[data-removal-locality]');
    const postcode = container.querySelector('[data-removal-postcode]');
    street.setCustomValidity(address.street.length >= 5 ? '' : 'Enter the full street address, including street number and any unit.');
    locality.setCustomValidity(zoneFor(address.locality) ? '' : contact);
    postcode.setCustomValidity(/^\d{4}$/.test(address.postcode) ? '' : 'Enter a four-digit New Zealand postcode.');
    const valid = address.street.length >= 5 && !!priceFor(address.locality) && /^\d{4}$/.test(address.postcode);
    return report ? [street, locality, postcode].every(field => field.reportValidity()) && valid : valid;
  };
  const clearQuote = container => {
    delete container.dataset.quote;
    delete container.dataset.quotePrice;
    const summary=container.querySelector('[data-removal-price-summary]');
    if (summary) {summary.textContent='';summary.hidden=true;}
  };
  const showError = (container, error) => {
    const shownPrice=container.dataset.quotePrice;
    clearQuote(container);
    if (shownPrice) container.dataset.quotePrice=shownPrice;
    const output = container.querySelector('[data-removal-status]');
    output.textContent = error.message || String(error); output.setAttribute('role','alert');
  };
  const revealPrice = container => {
    if (!window.matchMedia?.('(max-width: 767px)').matches) return;
    const output = container.querySelector('[data-removal-status]');
    requestAnimationFrame(() => output.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center'
    }));
  };
  const quote = (container, {report = true, reveal = true} = {}) => {
    const output = container.querySelector('[data-removal-status]');
    if (!validAddress(container, report)) {
      clearQuote(container);
      output.textContent = report ? contact : '';
      return false;
    }
    const address = readAddress(container);
    const zone = zoneFor(address.locality);
    container.dataset.quote = JSON.stringify(address);
    container.dataset.quotePrice = String(priceFor(address.locality));
    output.setAttribute('role', 'status');
    output.textContent = `${money(priceFor(address.locality))} incl. GST for one old mattress — ${zone} zone. Outdoor collection only. We’ll confirm collection arrangements.`;
    const summary=container.querySelector('[data-removal-price-summary]');
    if (summary) {summary.textContent=output.textContent;summary.hidden=false;}
    if (reveal) revealPrice(container);
    return true;
  };
  const productStates = new WeakMap();
  const persistProduct = card => {
    const state=productStates.get(card);
    clearTimeout(state.timer);
    if (!card.querySelector('[data-removal-select]').checked) return pending;
    if (!quote(card,{report:false,reveal:false})) return Promise.reject(new Error(contact));
    const address=readAddress(card), signature=JSON.stringify(address);
    if (state.saved===signature) return pending;
    if (state.queued===signature) return state.operation;
    const revision=++state.revision;
    state.queued=signature;
    const operation=attributes({[keys.requested]:'Requested',[keys.street]:address.street,[keys.locality]:address.locality,[keys.postcode]:address.postcode});
    state.operation=operation.then(()=>{
      if (revision===state.revision) {state.saved=signature;state.queued='';}
    }).catch(error=>{
      if (revision===state.revision) {state.queued='';showError(card,error);}
      throw error;
    });
    return state.operation;
  };
  const ensureProductSaved = async card => {
    const checkbox=card?.querySelector('[data-removal-select]');
    while (checkbox?.checked) {
      if (!validAddress(card)) throw new Error(contact);
      const signature=JSON.stringify(readAddress(card));
      await persistProduct(card);
      if (checkbox.checked && signature===JSON.stringify(readAddress(card)) && productStates.get(card).saved===signature) return;
    }
    await productStates.get(card)?.cleanup;
    await pending;
  };
  const initProduct = card => {
    if (card.dataset.ready) return;
    card.dataset.ready = 'true';
    const checkbox = card.querySelector('[data-removal-select]');
    const details = card.querySelector('[data-removal-address-wrap]');
    const form = document.getElementById(card.dataset.form);
    const state={timer:null,revision:0,current:'',saved:'',queued:'',operation:Promise.resolve(),cleanup:null};
    productStates.set(card,state);
    const recheck = event => {
      event?.target.setCustomValidity?.('');
      clearTimeout(state.timer);
      if (!checkbox.checked) return;
      const signature=JSON.stringify(readAddress(card));
      if (signature!==state.current) {state.current=signature;state.revision++;state.saved='';state.queued='';}
      if (quote(card,{report:false,reveal:false})) {
        state.timer=setTimeout(()=>persistProduct(card).catch(()=>{}),250);
      } else {
        const address=readAddress(card);
        card.querySelector('[data-removal-status]').textContent=address.locality && !zoneFor(address.locality) ? contact : '';
      }
    };
    const setSelected = async () => {
      const revision=++state.revision;
      clearTimeout(state.timer); state.saved='';state.queued='';
      details.hidden = !checkbox.checked;
      clearQuote(card);
      card.querySelector('[data-removal-status]').textContent = '';
      try {
        if (checkbox.checked && quote(card,{report:false,reveal:false})) {await persistProduct(card);return;}
        if (checkbox.checked) {await attributes({[keys.requested]:'Requested'});return;}
        markSelection(false);
        const cleanup=enqueue(async()=>{
          if (checkbox.checked || revision!==state.revision) return;
          await api('cart/update.js',{attributes:{[keys.requested]:'',[keys.street]:'',[keys.locality]:'',[keys.postcode]:''}});
          if (checkbox.checked || revision!==state.revision) return;
          const cart=await api('cart.js');
          const updates=Object.fromEntries(cart.items.filter(service).map(item=>[item.key,0]));
          if (!checkbox.checked && revision===state.revision && Object.keys(updates).length) await api('cart/update.js',{updates});
        });
        state.cleanup=cleanup;
        try {await cleanup;}
        finally {if (state.cleanup===cleanup) state.cleanup=null;}
      } catch (error) {
        if (revision===state.revision) {
          if (!checkbox.checked) markSelection(true);
          showError(card,error);
        }
      }
    };
    checkbox.addEventListener('change', setSelected);
    card.querySelector('[data-removal-check]')?.addEventListener('click',()=>persistProduct(card).catch(error=>showError(card,error)));
    details.addEventListener('input',recheck);
    details.addEventListener('change',recheck);
    if (form) form.dataset.removalForm = card.id;
    details.hidden=!checkbox.checked;
    if (checkbox.checked) recheck();
  };
  const productCard = form => form && document.getElementById(form.dataset.removalForm);
  const productReady = card => {
    if (!card?.querySelector('[data-removal-select]')?.checked) return true;
    return quote(card,{report:true,reveal:false});
  };
  const replayingProductForms = new WeakSet();
  const submittingProductForms = new WeakSet();
  document.addEventListener('submit', event => {
    const card = productCard(event.target);
    if ((card?.querySelector('[data-removal-select]')?.checked || productStates.get(card)?.cleanup) && !replayingProductForms.has(event.target)) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (submittingProductForms.has(event.target) || !productReady(card)) return;
      const form=event.target, submitter=event.submitter;
      submittingProductForms.add(form);
      ensureProductSaved(card).then(async()=>{
        await new Promise(resolve=>setTimeout(resolve,0));
        await ensureProductSaved(card);
        replayingProductForms.add(form);
        try {form.requestSubmit(submitter?.isConnected===false ? undefined : submitter);}
        finally {replayingProductForms.delete(form);}
      }).catch(error=>showError(card,error)).finally(()=>submittingProductForms.delete(form));
      return;
    }
    if (event.target.id==='cart' && (event.submitter?.name==='checkout' || hasRemoval)) {event.preventDefault();event.stopImmediatePropagation();if(event.submitter) event.submitter.click(); else {const booking=document.querySelector('[data-removal-booking]'); if(booking) initBooking(booking,true).then(()=>{booking.hidden=false;booking.querySelector('form')?.requestSubmit();}).catch(error=>showError(booking,error));}}
  }, true);
  document.addEventListener('click', async event => {
    const buy = event.target.closest('.sp-buy-now-button');
    if (buy) {
      const wrapper = buy.closest('sleepy-buy-now');
      const add = wrapper?.querySelector('[name="add"]');
      const form = add?.form;
      const card = productCard(form);
      if (!card?.querySelector('[data-removal-select]')?.checked && !hasRemoval && !productStates.get(card)?.cleanup) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (!productReady(card) || !form.reportValidity()) return;
      buy.disabled = true;
      try {
        await ensureProductSaved(card);
        const data = new FormData(form); data.delete('sections'); data.delete('sections_url');
        const response = await fetch(root + 'cart/add.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || 'Unable to add mattress.');
        window.location.assign(root + 'cart#sleepy-removal-booking');
      } catch(error) { showError(card,error); buy.disabled=false; }
      return;
    }
    const candidate = event.target.closest('button');
    const checkout = event.target.closest('[name="checkout"], a[href$="/checkout"], [data-removal-drawer-checkout]') || (candidate?.textContent.trim()==='Checkout' ? candidate : null);
    if (!checkout) return;
    if (checkout.closest('[data-removal-booking]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try {
      await pending;
      const cart = await api('cart.js');
      if (cart.attributes[keys.requested] || cart.items.some(service)) {
        if (location.pathname.replace(/\/$/,'').endsWith('/cart')) {
          const booking = document.querySelector('[data-removal-booking]');
          if (booking) { await initBooking(booking,true); booking.hidden=false; booking.querySelector('form')?.requestSubmit(); }
          else window.location.assign(root + 'cart#sleepy-removal-booking');
        } else window.location.assign(root + 'cart#sleepy-removal-booking');
      } else window.location.assign(root + 'checkout');
    } catch(error) { window.alert(error.message); }
  }, true);
  const bookingStates = new WeakMap();
  const initBooking = async (booking, retry = false, refresh = false) => {
    const form = booking.querySelector('form');
    const remove = booking.querySelector('[data-removal-remove]');
    const check = booking.querySelector('[data-removal-check]');
    let state = bookingStates.get(booking);
    if (!state) {
      state = {ready:false, loading:null, saving:false, touched:new Set(),editRevision:0,fieldEdits:new Map(),restore:null};
      bookingStates.set(booking,state);
      const touch = event => {
        if (event.target.name) {
          state.touched.add(event.target.name);
          state.fieldEdits.set(event.target.name,++state.editRevision);
        }
      };
      form.addEventListener('input',touch);
      form.addEventListener('change',touch);
      check?.addEventListener('click', async () => {
        try { await initBooking(booking,true); if (!state.saving) quote(booking); }
        catch(error) { showError(booking,error); }
      });
      const recheck = event => {
        event.target.setCustomValidity?.('');
        if (state.saving) return;
        if (!quote(booking,{report:false,reveal:false})) {
          const address = readAddress(booking);
          booking.querySelector('[data-removal-status]').textContent = address.locality && !zoneFor(address.locality) ? contact : '';
        }
      };
      const addressFields = booking.querySelector('[data-removal-address]');
      addressFields.addEventListener('input',recheck);
      addressFields.addEventListener('change',recheck);
      remove.addEventListener('click', async () => {
        if (state.saving) return;
        state.saving=true; remove.disabled=true;
        try {
          await pending;
          const current=await api('cart.js');
          const updates=Object.fromEntries(current.items.filter(service).map(item=>[item.key,0]));
          await api('cart/update.js',{updates,attributes:{[keys.requested]:'',[keys.street]:'',[keys.locality]:'',[keys.postcode]:''}});
          location.assign(root+'cart');
        } catch(error) { showError(booking,error);state.saving=false;remove.disabled=false; }
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (state.saving) return;
        try { await initBooking(booking,true); }
        catch(error) { showError(booking,error);return; }
        if (state.saving || !validAddress(booking) || !form.reportValidity()) return;
        const address=readAddress(booking), zone=zoneFor(address.locality), price=priceFor(address.locality);
        const previousAddress=booking.dataset.quote, previousPrice=booking.dataset.quotePrice;
        quote(booking,{report:false,reveal:false});
        if (previousAddress!==JSON.stringify(address) && previousPrice!==String(price)) {
          const output=booking.querySelector('[data-removal-status]');
          output.setAttribute('tabindex','-1'); output.focus(); revealPrice(booking); return;
        }
        const variant=config.variants.find(item=>item.title===zone);
        const properties=Object.fromEntries(new FormData(form).entries());
        delete properties.confirm;
        for (const field of ['street','locality','postcode']) properties[keys[field]]=address[field];
        properties['Collection zone']=zone;
        properties['Service']='Saver outdoor collection — one old mattress';
        properties['Collection timing']='Within three days of confirmed booking; collection confirmed separately';
        properties['_sleepy_removal']='v1';
        const controls=Array.from(form.elements, input=>({input,disabled:input.disabled,value:input.value,checked:input.checked}));
        const restore=()=>{
          controls.forEach(({input,disabled})=>{input.disabled=disabled;});
          state.saving=false; booking.removeAttribute('aria-busy');
          if (state.restore===restore) state.restore=null;
        };
        state.restore=restore;
        let leaving=false;
        state.saving=true; booking.setAttribute('aria-busy','true');
        controls.forEach(({input})=>{input.disabled=true;});
        try {
          if (!variant || !variant.available || variant.price !== price) throw new Error('This collection option is not available yet. Please contact SleepyCo.');
          await pending;
          let current=await api('cart.js');
          if (!current.items.some(eligible)) throw new Error('Add a new mattress before booking removal.');
          const lines=current.items.filter(service);
          const keep=lines.find(item=>Number(item.variant_id)===Number(variant.id));
          const updates=Object.fromEntries(lines.filter(item=>item!==keep).map(item=>[item.key,0]));
          if (Object.keys(updates).length) {
            await api('cart/update.js',{updates});
            current=await api('cart.js');
          }
          if (!current.items.some(eligible)) throw new Error('Add a new mattress before booking removal.');
          const currentKeep=current.items.find(item=>service(item) && Number(item.variant_id)===Number(variant.id));
          if (currentKeep) await api('cart/change.js',{id:currentKeep.key,quantity:1,properties});
          else await api('cart/add.js',{items:[{id:variant.id,quantity:1,properties}]});
          await attributes({[keys.requested]:'Confirmed',[keys.street]:address.street,[keys.locality]:address.locality,[keys.postcode]:address.postcode});
          const verified=await api('cart.js');
          const services=verified.items.filter(service);
          const line=services[0];
          const unchanged=controls.every(({input,value,checked})=>input.value===value && input.checked===checked);
          const saved=Object.entries(properties).every(([key,value])=>String(line?.properties?.[key] ?? '')===String(value));
          const savedAddress=['street','locality','postcode'].every(field=>verified.attributes[keys[field]]===address[field]);
          if (!unchanged || services.length!==1 || line.quantity!==1 || Number(line.variant_id)!==Number(variant.id) || Number(line.price)!==price || !saved || !savedAddress || verified.attributes[keys.requested]!=='Confirmed' || !verified.items.some(eligible)) throw new Error('Your cart changed. Please review your collection booking again.');
          window.location.assign(root+'checkout'); leaving=true;
        } catch(error) { showError(booking,error); }
        finally {
          if (!leaving) {
            restore();
          }
        }
      });
    }
    if (refresh && state.loading) {
      try {await state.loading;} catch {}
      return initBooking(booking,true,true);
    }
    if (refresh) state.ready=false;
    if (state.ready || state.loading || (booking.dataset.ready==='error' && !retry)) return state.loading;
    const refreshRevision=state.editRevision;
    booking.dataset.ready='loading';
    state.loading=(async()=>{
      await pending;
      const cart=await api('cart.js');
      const existing=cart.items.filter(service);
      booking.hidden=!(cart.attributes[keys.requested] || existing.length);
      if (!booking.hidden) {
        if (!cart.items.some(eligible)) {
          const updates=Object.fromEntries(existing.map(item=>[item.key,0]));
          await api('cart/update.js',{updates,attributes:{[keys.requested]:''}});
          state.ready=true; booking.dataset.ready='true';
          location.replace(root+'cart'); return;
        }
        const props=existing[0]?.properties || {};
        const addressKeys=['street','locality','postcode'].map(field=>keys[field]);
        for (const input of form.elements) {
          if (!input.name) continue;
          const refreshAddress=refresh && addressKeys.includes(input.name) && (state.fieldEdits.get(input.name) || 0)<=refreshRevision;
          if (state.touched.has(input.name) && !refreshAddress) continue;
          const value=addressKeys.includes(input.name) && Object.hasOwn(cart.attributes,input.name) ? cart.attributes[input.name] : props[input.name];
          if (value != null) input.value=value;
        }
        quote(booking,{report:false,reveal:false});
      }
      state.ready=true; booking.dataset.ready='true';
    })().catch(error=>{booking.dataset.ready='error';throw error;}).finally(()=>{state.loading=null;});
    return state.loading;
  };
  const init = () => {
    document.querySelectorAll('[data-removal-product]').forEach(initProduct);
    document.querySelectorAll('[data-removal-booking]').forEach(booking => initBooking(booking).catch(error=>showError(booking,error)));
    document.querySelectorAll('a[href$="/checkout"]').forEach(button=>button.dataset.removalDrawerCheckout='true');
  };
  init();document.addEventListener('shopify:section:load',init);
  window.addEventListener?.('pageshow',event=>{
    if (!event.persisted) return;
    document.querySelectorAll('[data-removal-booking]').forEach(booking=>{
      const state=bookingStates.get(booking);
      state?.restore?.();
      if (state) {state.saving=false;booking.removeAttribute('aria-busy');}
      clearQuote(booking);
      initBooking(booking,true,true).catch(error=>showError(booking,error));
    });
  });
  window.addEventListener?.('online',()=>document.querySelectorAll('[data-removal-booking]').forEach(booking=>initBooking(booking,true).catch(error=>showError(booking,error))));
  let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;init();});}).observe(document.body,{childList:true,subtree:true});
})();
